import React from 'react';
import './WhyClean.css'; // Ensure this path is correct



const WhyClean = () => {
  return (
    <div className="whyClean">
      <img src="/WhyClean.jpg" alt="Clean Solar Panel" />
      <div className="overlay2">
        <h1 className="overlay-text2">Why Clean?</h1>
      </div>
      <div className="content">
        <h1 className="reason">
          Ecoclean Solar Solutions emphasizes the importance of regular cleaning and maintenance of solar panels to optimize their efficiency and longevity. By keeping solar panels clean, we ensure maximum power generation and prevent degradation caused by dirt and debris. Our specialized cleaning services contribute to a more sustainable and cost-effective solar energy system in Pakistan.
        </h1>
        <h1 className="additional-heading">Does cleaning Solar Panels help?</h1>
        <p className="additional-text">
          Let’s discuss in detail the benefits and main reasons why we emphasize cleaning and maintaining your Solar panels.
        </p>
        <div className="benefits-container">
          <div className="benefit-box">
            <h2>Maximizing Energy Production</h2>
            <p>
              Solar panels generate electricity by converting sunlight into usable energy. However, when dust, dirt, or debris accumulate on the surface of the panels, it obstructs the sunlight from reaching the photovoltaic cells, reducing their efficiency. Regular cleaning ensures maximum exposure to sunlight, resulting in optimal energy production and higher electricity generation.
            </p>
           
          </div>
          <div className="benefit-box">
            <h2>Overcoming Pollution Challenges</h2>
            <p>
              Pakistan is known for its arid climate and high levels of dust and air pollution. These environmental factors pose significant challenges to solar panels, as dust particles settle on their surfaces, impeding the sun’s rays. By regularly cleaning the panels, especially in dusty areas, dust and pollutants can be minimized, ensuring consistent energy production.
            </p>
           
          </div>
          <div className="benefit-box">
            <h2>Prolonging Panel Lifespan</h2>
            <p>
              Solar panels are long-term investments, typically designed to last for several decades. However, neglecting their maintenance can lead to premature degradation and a shortened lifespan. Dust and debris can create hotspots on panels, causing potential damage to the cells and reducing their overall performance. Regular cleaning helps prevent these issues, extending the panels’ lifespan and maximizing the return on investment.
            </p>
            
          </div>
          <div className="benefit-box">
            <h2>Improving Return On Investment</h2>
            <p>
              Solar energy systems are substantial investments for individuals and businesses alike. By ensuring proper panel cleaning and maintenance, owners can optimize their system’s performance, resulting in increased energy production. This translates into higher savings on electricity bills and a quicker return on investment.
            </p>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyClean;
